<template>
  <div class="bigBox">
    <div class="bgcBox"></div>
    <Header class="headBox" :color="'#fff'" />
    <!-- head title -->
    <div class="titleBox">
      <img src="./assets/images/titleIcon.png" alt="" />
      <p>
        El cliente tiene conocimiento que la información está sujeta a
        evaluación y verificación. En caso la información haya sido ingresada de
        manera incompleta, errónea o falsa, no se aprobará la solicitud del
        crédito.
      </p>
    </div>
    <!-- identify main -->
    <div class="mainBox">
      <div class="cameraBox">
        <img src="./assets/images/identifyLoding.png" alt="" />
        <FaceRecognition
          @openloading="openloading"
          ref="cameraRef"
          @complate="complate"
        />
      </div>
      <p class="titleText">
        Por favor coloque su cara en el marco y no se mueva después de hacer
        click en
      </p>
      <h3 class="titleTextH3">EMPEZAR A VERIFICAR</h3>
      <div @click="photograph" class="photographBtn">EMPEZAR A VERIFICAR</div>
      <img style="width: 5.86rem" src="./assets/images/ruleImg.png" alt="" />
    </div>
    <ContactOrAbout />

    <van-overlay :show="loading">
      <div class="loadingIcon">
        <i class="el-icon-loading"></i>
        <p>
          loading...
        </p>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import FaceRecognition from "./components/faceRecognition.vue";
import Header from "./components/header.vue";
import ContactOrAbout from "./components/contactOrAbout.vue";
import { orderConfirm } from "../utils/api/h5page";
export default {
  components: {
    Header,
    FaceRecognition,
    ContactOrAbout,
  },
  name: "",
  props: {},
  data() {
    return {
      loading: false,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    photograph() {
      this.$refs.cameraRef.photoShoot();
    },
    complate() {
      const jsonData = JSON.parse(sessionStorage.getItem("jsonData"));
      const params = {
        loan: jsonData.loanNum,
        period: jsonData.loanDay,
        is_new: 1,
        coupon_id: "",
        order_label: "FAST_RELOAN",
        token_key: localStorage.getItem("tokenKey"),
      };
      // this.loading = true;
      orderConfirm(params).then(({ data }) => {
        if (data.code == 0) {
          this.$router.push({ path: "/h5Page/home" });
        } else if (data.code == 500) {
          this.$Toast("error");
        }
        this.loading = false;
      });
    },

    openloading() {
      this.loading = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.bigBox {
  padding: 0 0.2rem 0.2rem;
  background-color: #f5f5f5;
}
.bgcBox {
  position: absolute;
  left: 0;
  top: 0;
  background: linear-gradient(180deg, #fb5555 0%, #f5f5f5 100%);
  width: 100%;
  height: 5.37rem;
}
.headBox {
  padding-top: 0.5rem;
}

.titleBox {
  position: relative;
  display: flex;
  z-index: 10;
  width: 100%;
  height: 1.08rem;
  background: #fbf7ec;
  border-radius: 0.2rem;
  margin: 0.24rem 0 0.3rem;
  padding: 0.17rem 0.18rem 0;
  img {
    width: 0.4rem;
    height: 0.4rem;
    margin-right: 0.14rem;
  }
  p {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.17rem;
    color: #8a7a51;
    line-height: 0.25rem;
  }
}

.mainBox {
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background: #ffffff;
  border-radius: 0.2rem;
  padding: 0.52rem 0;
  margin-bottom: 0.3rem;
  .cameraBox {
    position: relative;
    width: 4.1rem;
    height: 4.1rem;
    border-radius: 50%;
    overflow: hidden;
    img {
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      animation: roteImg 1s linear infinite;
    }
  }
  .titleText {
    width: 5.31rem;
    text-align: center;
    font-size: 0.28rem;
    line-height: 0.33rem;
    color: #333;
    margin-top: 0.54rem;
  }
  .titleTextH3 {
    font-size: 0.28rem;
    line-height: 0.33rem;
    color: #333;
    font-weight: 700;
    margin-bottom: 0.46rem;
  }
  .photographBtn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 5.8rem;
    height: 0.8rem;
    background: #c90000;
    border-radius: 0.4rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.32rem;
    color: #ffffff;
    margin-bottom: 0.5rem;
  }
}

.loadingIcon {
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -70%);
  font-size: 0.35rem;
  color: #409eff;
  i {
    font-size: 0.65rem;
    margin-bottom: 0.2rem;
  }
}

.van-overlay {
  z-index: 25;
}

@keyframes roteImg {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
